import React from 'react';
import JsonView from './JsonView';
import Util from '../Util';
import $ from 'jquery';
import Api from '../Api';

class SheldonCmd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      path: '',
      content: '',
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleKskapiRestart() {
    let p = this.handleButtonClick('restart-kskapi');

    let hostInfo = this.props.hostInfo;
    // for MQ kiosk, the kskapi handle MQ message and restarting or stopping
    // of kskapi will always timed out.
    // So fire another request to get kskapi status after restart
    if (hostInfo.isMQKskType) {
      p.always(() => {
        this.setState({
          content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
        });
        setTimeout(() => {
          this.handleButtonClick('status-kskapi');
        }, 10000);
      });
    }
  }

  handleButtonClick(type) {
    let { onCmdClick } = this.props;
    let { ip, authType, kioskTouchDriver } = this.props.hostInfo;
    let { auth: { user }, } = this.props;
    let hostInfo = this.props.hostInfo;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let method = 'GET';
    let path = '';
    let dataType = 'json';
    let timeout = 90000;
    let wrapView = false;

    let linuxdash = Util.getLinuxDashPath(hostInfo);
    let kskapi = Util.getKskApiPath(hostInfo);
    let capui = Util.getCapUIPath(hostInfo);
    let payapi = Util.getPayApiPath(hostInfo);

    switch (type) {
      case 'fullsync':
        path = `${kskapi}/sync/full`;
        break;
      case 'updpricingrec':
        path = `${kskapi}/sync/updpricingrec`;
        break;
      case 'uploadtq':
        path = `${kskapi}/sync/uploadtq`;
        break;
      case 'viewtq':
        path = `${linuxdash}/server/?module=view_kskdb_first_trans`;
        dataType = 'text';
        wrapView = true;
        break;
      case 'backuptq':
        path = `${linuxdash}/server/?module=backup_kskdb_stuck_trans`;
        dataType = 'text';
        if (!window.confirm(
            'Click on the "Upload Transaction Queue" and ' +
            '"View First Transaction in Queue" buttons first to make sure transaction are stuck ' +
            'in queue before backing it up. ' +
            '\nConfirm backup?')) {
          return;
        }
        break;
      case 'uploadccque':
        path = `${payapi}/cmd?uploadquarantine=yes`;
        break;
      case 'upgradedb':
        path = `${kskapi}/sync/upgradedb`;
        break;
      case 'syncprinters':
        path = `${kskapi}/sync/syncprinters`;
        break;
      case 'clearmd5':
        path = `${kskapi}/sync/clearmd5`;
        break;
      case 'optserialno':
        path = `${kskapi}/sync/getoptconnectslno`;
        break;
      case 'install-elo-single-touch-driver':
        if (
          !window.confirm(
            'Current Touch Driver is ' + kioskTouchDriver + ' driver. Confirm Install?'
          )
        ) {
          return;
        }
        method = 'POST';
        path = `elo-touch-driver?cmd=install-elo-single-touch-driver&ipaddr=${ip}&authType=${authType}&sender=${user.email}`;
        dataType = 'text';
        break;
      case 'disable-elo-touch-beep':
        method = 'POST';
        path = `elo-touch-driver?cmd=disable-elo-touch-beep&ipaddr=${ip}&authType=${authType}&sender=${user.email}`;
        dataType = 'text';
        break;
      case 'reset-probe-config':
        method = 'POST';
        if (!window.confirm('Reset kiosk id, name and location name in probe-config.json?')) {
          return;
        }
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` +
          encodeURIComponent('--kiosk-fix=--reset-probe-config');
        dataType = 'text';
        break;
      case 'convert-capui-to-electron-for-mm':
        method = 'POST';
        if (
          !window.confirm(
            'This will update desktop, reset probe-config.json, and reboot kiosk if capui running on browser. Confirm?'
          )
        ) {
          return;
        }
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` +
          encodeURIComponent('--kiosk-fix=--convert-capui-to-electron-for-mm');
        dataType = 'text';
        break;
      case 'force-update-oti-firmware':
        method = 'POST';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` +
          encodeURIComponent('--force-update-oti-firmware');
        dataType = 'text';
        break;
      case 'update-oti-firmware':
        method = 'POST';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` + encodeURIComponent('--update-oti-firmware');
        dataType = 'text';
        break;
      case 'turn-on-oti-log':
        method = 'POST';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` + encodeURIComponent('--turn-on-oti-log');
        dataType = 'text';
        break;
      case 'turn-off-oti-log':
        method = 'POST';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` + encodeURIComponent('--turn-off-oti-log');
        dataType = 'text';
        break;
      case 'long_list_print_jobs':
        method = 'POST';
        path = `${linuxdash}/exec/cups?args=long_list_print_jobs`;
        dataType = 'text';
        break;
      case 'list_all_printers_status':
        method = 'POST';
        path = `${linuxdash}/exec/cups?args=list_all_printers_status`;
        dataType = 'text';
        break;
      case 'list_all_printers_option':
        method = 'POST';
        path = `${linuxdash}/exec/cups?args=list_all_printers_option`;
        dataType = 'text';
        break;
      case 'list_cups_settings':
        method = 'POST';
        path = `${linuxdash}/exec/cups?args=list_cups_settings`;
        dataType = 'text';
        break;
      case 'cancel_all_pending_print_jobs':
        if (!window.confirm('Cancel all pending print jobs?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/cups?args=cancel_all_pending_print_jobs`;
        dataType = 'text';
        break;
      case 'restart-kskapi':
        if (!window.confirm('Restart kskapi?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=kskapi%20restart`;
        dataType = 'text';
        break;
      case 'restart-payapi':
        if (!window.confirm('Restart payapi?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=payapi%20restart`;
        dataType = 'text';
        break;
      case 'restart-printapi':
        if (!window.confirm('Restart printapi?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=printapi%20restart`;
        dataType = 'text';
        break;
      case 'restart-capui':
        if (!window.confirm('Restart capui?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=pm2-init.sh%20restart%20capui%20--no-color`;
        dataType = 'text';
        break;
      case 'restart-heatwave':
        if (!window.confirm('Restart heatwave?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=heatwave%20restart`;
        dataType = 'text';
        break;
      case 'restart-cafeapi':
        if (!window.confirm('Restart cafeapi?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=cafeapi%20restart`;
        dataType = 'text';
        break;
      case 'restart-baitapi':
        if (!window.confirm('Restart baitapi?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=baitapi%20restart`;
        dataType = 'text';
        break;
      case 'stop-heatwave':
        if (!window.confirm('Stop heatwave?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/service?args=heatwave%20stop`;
        dataType = 'text';
        break;
      case 'status-kskapi':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=kskapi%20status`;
        dataType = 'text';
        break;
      case 'status-payapi':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=payapi%20status`;
        dataType = 'text';
        break;
      case 'status-printapi':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=printapi%20status`;
        dataType = 'text';
        break;
      case 'status-capui':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=pm2-init.sh%20status%20capui%20`;
        dataType = 'text';
        break;
      case 'status-heatwave':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=heatwave%20status`;
        dataType = 'text';
        break;
      case 'status-linuxdash':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=linuxdash%20status`;
        dataType = 'text';
        break;
      case 'status-cafeapi':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=cafeapi%20status`;
        dataType = 'text';
        break;
      case 'status-baitapi':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=baitapi%20status`;
        dataType = 'text';
        break;
      case 'install-team-viewer':
        if (
          !window.confirm(
            'Make sure Team Viewer is not installed. Installation could take a few minutes. Continue?'
          )
        ) {
          return;
        }
        method = 'POST';
        dataType = 'text';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` +
          encodeURIComponent('--run-kiosk-script=install-team-viewer.sh');
        break;
      case 'closebrowser':
        if (!window.confirm('Close all browser windows?')) {
          return;
        }
        method = 'POST';
        path = `${linuxdash}/exec/close-browsers`;
        break;
      case 'reset-electron-browser':
        if (!window.confirm('Clear electron browser cache and restart the browser in Kiosk app?')) {
          return;
        }
        method = 'POST';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` +
          encodeURIComponent('kiosk-fix=reset-kiosk-probe-capui');
        dataType = 'text';
        break;
      case 'reboot':
        if (!window.confirm('Reboot kiosk?')) {
          return;
        }
        path = `${capui}/reboot`;
        break;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    return $.ajax({ url: path, dataType: dataType, method: method, timeout: timeout })
      .always(() => {
        this.inProgress = false;
        onCmdClick();
      })
      .done((data) => {
        if (dataType === 'json') {
          this.setState(
            {
              content: <JsonView title={path} data={data} />,
            },
            () => {
              // let $content = $(this.refs.content);
              // $content.scrollTop($content[0].scrollHeight); // scroll to bottom
            }
          );
        } else {
          this.setState({
            content: wrapView ? <div>{data}</div> : <pre style={{ color: '' }}>{data}</pre>,
          });
        }
        if (type == 'backuptq') {
          Api.sendBackuptqEvent(data);
        }
      })
      .fail((jqXHR) => {
        if (
          type === 'fullsync' &&
          jqXHR.statusText === 'parsererror' &&
          jqXHR.responseText.includes('timeout')
        ) {
          this.setState({
            content: (
              <span style={{ color: 'red' }}>
                <b>Check Last Full Sync time stamp to verify if full sync was successful</b>
              </span>
            ),
          });
        } else {
          this.setState({
            content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
          });
        }
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { type } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>Command Launcher</h2>
        <div className='sheldon-buttons'>
          <button
            className={type === 'fullsync' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'fullsync')}
          >
            Full Sync
          </button>
          <button
            className={
              type === 'updpricingrec' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'updpricingrec')}
          >
            Update Products & Menus
          </button>
          <button
            className={type === 'upgradedb' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'upgradedb')}
          >
            Upgrade Database
          </button>
          <button
            className={
              type === 'syncprinters' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'syncprinters')}
          >
            Sync Printers with printapi
          </button>
          <button
            className={type === 'clearmd5' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'clearmd5')}
          >
            Clear Images MD5
          </button>
          <br />
          <button
            className={type === 'uploadtq' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'uploadtq')}
          >
            Upload Transaction Queue
          </button>
          <button
            className={type === 'viewtq' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'viewtq')}
          >
            View First Transaction in Queue
          </button>
          <button
            className={type === 'backuptq' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'backuptq')}
          >
            Backup First Transaction in Queue
          </button>
          <button
            className={type === 'uploadccque' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'uploadccque')}
          >
            Upload CCQuarantine Queue
          </button>
          <br />
          <button
            className={
              type === 'install-elo-single-touch-driver'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'install-elo-single-touch-driver')}
          >
            Install ELO Single Touch Driver
                </button>
          <button
            className={
              type === 'disable-elo-touch-beep'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'disable-elo-touch-beep')}
          >
            Disable ELO Touch Beep
          </button>
          <button
            className={
              type === 'reset-probe-config' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'reset-probe-config')}
          >
            Reset Provisioner Config
          </button>
          <button
            className={
              type === 'convert-capui-to-electron-for-mm'
          ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'convert-capui-to-electron-for-mm')}
          >
            Convert capui to run on electron for V5
          </button>
          <br />
          <br />
          <button
            className={
              type === 'long_list_print_jobs' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'long_list_print_jobs')}
          >
            List Print Jobs
          </button>
          <button
            className={
              type === 'list_all_printers_status'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'list_all_printers_status')}
          >
            List Printers Status
          </button>
          <button
            className={
              type === 'list_all_printers_option'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'list_all_printers_option')}
          >
            List Printers Options
          </button>
          <button
            className={
              type === 'list_cups_settings' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'list_cups_settings')}
          >
            List CUPS Settings
          </button>
          <button
            className={
              type === 'cancel_all_pending_print_jobs'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'cancel_all_pending_print_jobs')}
          >
            Cancel All Print Jobs
          </button>
          <br />
          <br />
          <button
            className={
              type === 'restart-kskapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleKskapiRestart.bind(this)}
          >
            Restart kskapi
          </button>
          <button
            className={
              type === 'restart-payapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'restart-payapi')}
          >
            Restart payapi
          </button>
          <button
            className={
              type === 'restart-printapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'restart-printapi')}
          >
            Restart printapi
          </button>
          <button
            className={
              type === 'restart-capui' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'restart-capui')}
          >
            Restart capui
          </button>
          <button
            className={
              type === 'restart-heatwave' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'restart-heatwave')}
          >
            Restart heatwave
          </button>
          <button
            className={
              type === 'stop-heatwave' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'stop-heatwave')}
          >
            Stop heatwave
          </button>
          <button
            className={
              type === 'restart-cafeapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'restart-cafeapi')}
          >
            Restart cafeapi
          </button>
          <button
            className={
              type === 'restart-baitapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'restart-baitapi')}
          >
            Restart baitapi
          </button>
          <br />
          <button
            className={
              type === 'status-kskapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-kskapi')}
          >
            Status kskapi
          </button>
          <button
            className={
              type === 'status-payapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-payapi')}
          >
            Status payapi
          </button>
          <button
            className={
              type === 'status-printapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-printapi')}
          >
            Status printapi
          </button>
          <button
            className={
              type === 'status-capui' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-capui')}
          >
            Status capui
          </button>
          <button
            className={
              type === 'status-heatwave' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-heatwave')}
          >
            Status heatwave
          </button>
          <button
            className={
              type === 'status-linuxdash' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-linuxdash')}
          >
            Status linuxdash
          </button>
          <button
            className={
              type === 'status-cafeapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-cafeapi')}
          >
            Status cafeapi
          </button>
          <button
            className={
              type === 'status-baitapi' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'status-baitapi')}
          >
            Status baitapi
          </button>
          <br />
          <br />
          <button
            className={
              type === 'update-oti-firmware' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'update-oti-firmware')}
          >
            Update OTI Firmware
          </button>
          <button
            className={
              type === 'force-update-oti-firmware'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'force-update-oti-firmware')}
          >
            Force Update OTI Firmware
          </button>
          <button
            className={
              type === 'turn-on-oti-log' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'turn-on-oti-log')}
          >
            Turn on OTI log
          </button>
          <button
            className={
              type === 'turn-off-oti-log' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'turn-off-oti-log')}
          >
            Turn off OTI log
          </button>
          <br />
          <br />
          <button
            className={
              type === 'install-team-viewer' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'install-team-viewer')}
          >
            Install Team Viewer
          </button>
          <button
            className={type === 'optserialno' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'optserialno')}
          >
            Update OptConnect Serial Number
          </button>
          <br />
          <br />
          <button
            className={
              type === 'closebrowser' ? 'pure-button pure-button__selected' : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'closebrowser')}
          >
            Close Browser
          </button>
          <button
            className={
              type === 'reset-electron-browser'
                ? 'pure-button pure-button__selected'
                : 'pure-button'
            }
            onClick={this.handleButtonClick.bind(this, 'reset-electron-browser')}
          >
            Reset Electron Browser
          </button>
          <button
            className={type === 'reboot' ? 'pure-button pure-button__selected' : 'pure-button'}
            onClick={this.handleButtonClick.bind(this, 'reboot')}
          >
            Reboot
          </button>
        </div>
        <div className='sheldon-content sheldon-cmd'>
          {/*<div style={{fontWeight: 600, paddingTop: '20px'}}>{this.state.path}</div>*/}
          <div style={{ height: panelHeight - 460, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonCmd;



// WEBPACK FOOTER //
// ./src/components/SheldonCmd.js